var _excluded = ["title", "content", "icon", "background", "colorEmphasis", "pushSpace", "isOpen", "openOnClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import FlexContainerOrg from "../../organisms/FlexContainerOrg";
import FlexItemOrg from "../../organisms/FlexItemOrg";
import PushOrg from "../../organisms/PushOrg";
import { ContentWrapper, IconArrow, TextWrapper, Wrapper } from "./MessageAccordionMol.styles";
export var defaultProps = {
  background: "backgroundLight"
};
function MessageAccordionMol(_ref) {
  var title = _ref.title,
    content = _ref.content,
    icon = _ref.icon,
    _ref$background = _ref.background,
    background = _ref$background === void 0 ? defaultProps.background : _ref$background,
    colorEmphasis = _ref.colorEmphasis,
    pushSpace = _ref.pushSpace,
    isOpen = _ref.isOpen,
    openOnClick = _ref.openOnClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(!!isOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenValue = _useState2[0],
    setIsOpen = _useState2[1];
  var handleOnClick = function handleOnClick() {
    setIsOpen(function (value) {
      return !value;
    });
    if (openOnClick && !isOpenValue) {
      openOnClick(isOpenValue);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $background: background,
    $pushSpace: pushSpace
  }, restProps, {
    onClick: handleOnClick,
    $colorEmphasis: colorEmphasis
  }), /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: background
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, null, icon ? /*#__PURE__*/React.createElement(PushOrg, {
    rightSpace: 1
  }, icon) : null, /*#__PURE__*/React.createElement(ContentWrapper, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(FlexItemOrg, {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0
  }, title, /*#__PURE__*/React.createElement(TextWrapper, {
    isOpen: isOpenValue
  }, content)), /*#__PURE__*/React.createElement(PushOrg, {
    leftSpace: 1,
    hasNoReset: true
  }, /*#__PURE__*/React.createElement(IconArrow, {
    $isOpen: isOpenValue,
    $background: background
  }))))));
}
export default MessageAccordionMol;